import { money, pctPoints } from "./format";
import type { Currency } from "./types";

export const formatClimberUnits = (value: string | null, unavailable: boolean) => unavailable || value == null ? "–" : new Intl.NumberFormat("en-GB", { maximumFractionDigits: 0 }).format(Number(value));
export const formatClimberCash = (value: string | null, currency: Currency | null, places = 2) => currency && value != null ? money(value, currency, places) : "–";
export const formatClimberDelta = (value: string | null, currency: Currency | null, places = 2) => {
  if (!currency || value == null) return "–";
  return `${Number(value) > 0 ? "+" : ""}${money(value, currency, places)}`;
};
export const formatClimberPct = (value: string | null) => value == null ? "–" : pctPoints(value);
